<template>
<div class="chapter">
<div class="inner_page">
<p><a id="itr"></a></p><a id="itr">
<div class="fmhT sgc-1">
    INTRODUCTION
  </div>
<div class="fmtx1">
<b>T</b>rader Joe’s is a mecca of affordable, good-quality, delicious food—perfect for the college student who wants more than just cafeteria meals. With a little creativity and this cookbook in hand, you can transform Trader Joe’s ingredients into a mouth-watering array of nibbles and meals.
  </div>
<div class="fmtx">
    The purpose of this cookbook is to highlight basic recipes with step-by-step instructions, utilizing the wonder that is Trader Joe’s. Take it from someone who’s sampled every ingredient the company makes: From packaged snacks to fresh veggies to frozen meals, there’s a reason why the chain is so popular—the food is unique and tasty, and they’re constantly coming up with new products.
  </div>
<div class="centerAligned"><img alt="002" class="imgepub" src="Images/andr_9781569759516_oeb_002_r1.jpg"/></div>
<div class="fmtx">
    For the new cook, an onslaught of so many ingredients can be overwhelming, but this cookbook was created to work with the limited time and new cooking skills of a college student. From snacks to feed a study group to sandwiches for a lunch on the run to a quick soup on a cold day, this book’s got you covered. For dinner, you can use a microwave to whip up delicious dishes from your dorm room, tackle quick pasta recipes and hearty meals, and create special-occasion feasts for friends and family. There are even recipes for brain-boosting foods to help you out during exam weeks, and vegetarian options for when you need a little less meat. And, of course, what cookbook would be complete without a touch of dessert love? When you need a sweet treat in your life, tweak Trader Joe’s products for a quick fix.
  </div>
<div class="fmtx">
    Chock-full of 150 recipes all using the best Trader Joe’s has to offer, this book makes your job simple. Select a few recipes, head to your local Trader Joe’s, and relish in the delicious creativity that comes from combining their ingredients to make a feast.
  </div>
</a><div><a id="itr">
</a><a id="h1">
</a></div><a id="h1">
<h1 class="fmh1 sgc-2" id="heading_id_2">USING THIS BOOK</h1>
<div class="fmtx1 sgc-1">
    SUBSTITUTIONS
  </div>
<div class="fmtx1">
    One of the greatest things about Trader Joe’s is that in one shopping trip you can gather all the ingredients you’ll need to make the recipes in this book. But sometimes you’ll find that one location doesn’t carry a certain item, that your absolute favorite Trader Joe’s salsa has suddenly been discontinued, or that something you’re craving is only stocked around the holidays. No worries—although the recipes here are all made using many TJ’s specific ingredients, those can easily be substituted with a similar generic item. Or Trader Joe’s often has a similar ingredient in stock: Can’t find Trader Joe’s Misto alla Griglia? See if they have Trader Joe’s Grilled Eggplant and Zucchini Mélange. Use the recipes here as guidelines and you’ll still be whipping up delicious dishes in no time and getting back to that term paper you’ve been putting off.
  </div>
<div>
     <br/>
</div>
<div class="fmtx1 sgc-1">
    RECIPE ICONS
  </div>
<div class="fmtx1">
    Whether you’re looking for a quick snack to take to class or a heartier meal that you can still make with limited equipment (no stove? no problem!), handy icons accompany each recipe to quickly narrow your options: Microwave Only, One-Pot Cooking, Five-Minute Prep, No Cook, Grab and Go, and Vegetarian/Vegan. No matter what your cooking mood is, there’s a recipe to match.
  </div>
<div class="centerAligned">
<div class="centerAligned">
<table class="none">
<tbody><tr>
<td align="left" class="b r" valign="top"><img alt="003" class="imgepub" src="Images/andr_9781569759516_oeb_003_r1.gif"/></td>
<td align="left" class="b x sgc-3" valign="top">meals that can be prepared entirely in a microwave</td>
</tr>
<tr>
<td align="left" class="b r" valign="top"><img alt="004" class="imgepub" src="Images/andr_9781569759516_oeb_004_r1.gif"/></td>
<td align="left" class="b x sgc-3" valign="top">meals that require just one pot</td>
</tr>
<tr>
<td align="left" class="b r" valign="top"><img alt="005" class="imgepub" src="Images/andr_9781569759516_oeb_005_r1.gif"/></td>
<td align="left" class="b x sgc-3" valign="top">meals that can be prepared in five minutes or less</td>
</tr>
<tr>
<td align="left" class="b r" valign="top"><img alt="006" class="imgepub" src="Images/andr_9781569759516_oeb_006_r1.gif"/></td>
<td align="left" class="b x sgc-3" valign="top">meals that require no cooking</td>
</tr>
<tr>
<td align="left" class="b r" valign="top"><img alt="007" class="imgepub" src="Images/andr_9781569759516_oeb_007_r1.gif"/></td>
<td align="left" class="b x sgc-3" valign="top">meals that are great to take on the go</td>
</tr>
<tr>
<td align="left" class="x r" valign="top"><img alt="008" class="imgepub" src="Images/andr_9781569759516_oeb_008_r1.gif"/></td>
<td align="left" class="x x sgc-3" valign="top">meals that are vegetarian or vegan</td>
</tr>
</tbody></table>
</div>
</div></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// andr_9781569759516_oeb_itr_r1.vue?712e27e6